var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0424 6.23781C15.5276 6.68918 15.555 7.44852 15.1037 7.93374L11.2975 12.0254L15.3891 15.8315C15.8743 16.2829 15.9018 17.0422 15.4504 17.5275C14.999 18.0127 14.2397 18.0402 13.7544 17.5888L8.7842 12.9653C8.29898 12.5139 8.27154 11.7545 8.72291 11.2693L13.3464 6.2991C13.7978 5.81388 14.5571 5.78644 15.0424 6.23781Z",
    fill: "#1F97AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.b44fc1866af97f1bcee4deb2cf6131be.svg";
export { ForwardRef as ReactComponent };